import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./lead_time_source.js";
//#region src/lead_time_source_helper.ts
var lead_time_source_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(source) {
	switch (source) {
		case "location": return "Location Lead Time Rules";
		case "menu-item": return "Menu Item Prep Times";
	}
}
//#endregion
export { lead_time_source_helper_exports, name };

//# sourceMappingURL=lead_time_source_helper.js.map